import { React, useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import EmailIcon from '@mui/icons-material/Email';
import Switch from '@mui/material/Switch';
import SmsIcon from '@mui/icons-material/Sms';
import TuneIcon from '@mui/icons-material/Tune';
import TokenService from '../../services/TokenService'
function Profile(props) {

    const [preferenceEmailCommunication, setPreferenceEmailCommunication] = useState(props.loggedInUser == null ? '' : props.loggedInUser.EmailPreferences);
    const [preferencTextCommunication, setPreferenceTextCommunication] = useState(props.loggedInUser == null ? false : props.loggedInUser.SMS_NewPickups);
    let updatingValue = null;
    useEffect(() => {
        if (props.loggedInUser !== null && props.loggedInUser !== undefined) {
            // props changed
            setPreferenceEmailCommunication(props.loggedInUser.EmailPreferences);
            setPreferenceTextCommunication(props.loggedInUser.SMS_NewPickups);
        }
    }, [props]);

    function buildSkeleton() {
        return <div>
            <div>Communication Preferences</div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginLeft: '30px' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop:'10px' }}>
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginRight: '30px' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center' }} />
                <Skeleton variant="circular" width={25} height={25} style={{ alignSelf: 'center', marginLeft: '30px' }} />
            </div>
        </div>
    }

    function handleEmailPreferenceChange(event, emailPreference) {
        setPreferenceEmailCommunication(emailPreference);
        updatingValue = emailPreference;
        var postData = {
            EmailPreferences: emailPreference
        }
        TokenService.post(postData, 'MyAccountInfo_UpdateEmailPreferences')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    props.loggedInUser.EmailPreferences = updatingValue;
                    props.onChange(props.loggedInUser);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    };

    function handleTextCommunicationChanged(event, textPreference) {
        //Returner_PhoneNumber_UpdateSMS
        setPreferenceTextCommunication(textPreference);
        updatingValue = textPreference;
        var postData = {
            enableSMS: textPreference
        }
        TokenService.post(postData, 'Returner_PhoneNumber_UpdateSMS')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    props.loggedInUser.SMS_NewPickups = updatingValue;
                    props.onChange(props.loggedInUser);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildContent() {
        return <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ fontSize: '14pt', fontWeight: 'bold', marginBottom: '10px' }}>Preferences</div>
                <TuneIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, alignSelf: 'center' }} />
            </div>
            

            <div style={{display:'flex', justifyContent:'flex-start'} }>
                <EmailIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30,alignSelf: 'center' }} />
                <div style={{ alignSelf: 'center', marginLeft: 'auto', marginRight: 'auto' }}>Emails For New Pickups</div>
            </div>
            <ToggleButtonGroup
                color="primary"
                value={preferenceEmailCommunication}
                exclusive
                onChange={handleEmailPreferenceChange}
                aria-label="Email Preferences"
            >
                <ToggleButton style={{ fontSize: '9pt', backgroundColor:  (preferenceEmailCommunication  === 'Daily' ? 'var(--sipzee-yellow-2)' : '') }} value="Daily">Once Daily</ToggleButton>
                <ToggleButton style={{ fontSize: '9pt', backgroundColor: (preferenceEmailCommunication === 'Immediate' ? 'var(--sipzee-yellow-2)' : '') }} value="Immediate">Immediate</ToggleButton>
                <ToggleButton style={{ fontSize: '9pt', backgroundColor: (preferenceEmailCommunication === 'None' ? 'var(--sipzee-yellow-2)' : '') }} value="None">No Emails</ToggleButton>
            </ToggleButtonGroup>

            <div style={{ width: '100%', height: '2px', backgroundColor: 'var(--sipzee-gray-2)', marginTop:'15px', marginBottom:'5px' }}></div>

            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <SmsIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, alignSelf: 'center' }} />
                <div style={{ alignSelf: 'center', marginLeft: 'auto', marginRight: 'auto' }}>Text Alerts For New Pickups</div>
            </div>
            Off <Switch checked={preferencTextCommunication} onChange={handleTextCommunicationChanged} color='sipzeeYellow' /> On
        </div>
    }

    return (
        <Card sx={{ minWidth: 300, maxWidth: 400,width:'95%', alignSelf: 'center', margin: '10px' }}>
            <CardContent>
                {props.loggedInUser == null ? buildSkeleton() : buildContent()}
            </CardContent>
        </Card>
    );
}
export default Profile;